import { render } from "./SingleService.vue?vue&type=template&id=29c7f495"
import script from "./SingleService.vue?vue&type=script&lang=js"
export * from "./SingleService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__